import {
    Button,
    Col, Dropdown, Menu, Row, Space, Table, Typography,
} from 'antd';
import React, { useContext, useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';
import { DispersionContext } from '../context/dispersionContext';
import { InitialColumns } from './InititalColumns';
import { FileType } from '../../../types/reports';
import { parseData } from '../../../utils/userReport';

const { Title } = Typography;

const TransactionsTable = ({ refreshData }: { refreshData: () => void }) => {
    const INITIAL_COLUMNS: any = InitialColumns();
    const [fileType, setFileType] = useState<FileType>(FileType.CSV);
    const [loading, setLoading] = useState(false);

    const {
        dispersion,
        transactions,
        total,
        loadingTransactions,
        paginator,
        onPageChange,
    } = useContext(DispersionContext);

    const { limit, page } = paginator;

    const handleChangeFileType = (type: any) => {
        setFileType(type.key);
    };

    const menu = (
        <Menu onClick={handleChangeFileType}>
            <Menu.Item key={FileType.CSV}>CSV</Menu.Item>
            <Menu.Item key={FileType.XLSX}>XLSX</Menu.Item>
        </Menu>
    );

    const handleClick = () => {
        setLoading(true);
        parseData({
            rows: transactions,
            fileName: dispersion.dispersionUniqueID || dispersion.workspaceUniqueID,
            selectedRows: ['transactionId', 'bookingId', 'date', 'hour', 'businessName', 'type', 'amount', 'internalId', 'inStore', 'externalId', 'comment'],
            headersType: 'dispersionsReport',
            fileType,
        });
        setLoading(false);
    };

    const onChange = (pagination: any) => {
        onPageChange(pagination.current, pagination.pageSize);
    };

    return (
        <Table
            title={
                () => (
                    <Row justify="space-between">
                        <Col>
                            <Title level={4} style={{ marginBottom: 0 }}>
                                {`Transactions (${total || 0})`}
                            </Title>
                        </Col>
                        <Col>
                            <Space direction="horizontal" size={16} align="center">
                                <Button
                                    type="primary"
                                    icon={(
                                        <IoMdRefresh
                                            size={14}
                                            style={{ verticalAlign: 'middle' }}
                                        />
                                    )}
                                    onClick={refreshData}
                                />
                                <Dropdown.Button
                                    overlay={menu}
                                    trigger={['click']}
                                    type="primary"
                                    buttonsRender={([leftButton, rightButton]) => [
                                        React.cloneElement(leftButton as React.ReactElement<any, string>, { loading }),
                                        rightButton,
                                    ]}
                                    onClick={handleClick}
                                >
                                    Download
                                    {' '}
                                    {fileType}
                                </Dropdown.Button>
                            </Space>
                        </Col>
                    </Row>
                )
            }
            loading={loadingTransactions}
            columns={INITIAL_COLUMNS}
            dataSource={transactions}
            pagination={{
                total,
                current: page,
                pageSize: limit,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100', '150', '200'],
            }}
            onChange={onChange}
            bordered
            scroll={{ x: 1500 }}
            rowKey="_id"
        />
    );
};

export default TransactionsTable;
